import { business } from '@/config/business';

export const localBusinessSchema = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  name: business.name,
  url: `${business.siteUrl}/`,
  telephone: business.phone.e164,
  areaServed: business.operatingRegions,
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Nashville',
    addressRegion: 'TN',
    addressCountry: 'US',
  },
  description:
    'Professional 3D scanning and Matterport virtual tours serving Nashville and Middle Tennessee. Construction BIM services, legal documentation, commercial hospitality tours, and real estate marketing.',
};

export const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: business.name,
  url: `${business.siteUrl}/`,
  logo: `${business.siteUrl}/lovable-uploads/5d2a48a0-f17a-460b-ad2f-697c63898525.png`,
  telephone: business.phone.e164,
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: business.phone.e164,
    contactType: 'sales',
    areaServed: 'US',
    availableLanguage: 'English',
  },
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Nashville',
    addressRegion: 'TN',
    addressCountry: 'US',
  },
  sameAs: Object.values(business.social),
};

export const serviceSchema = (
  name: string,
  description: string,
  areaServed = 'Nashville, TN'
) => ({
  '@context': 'https://schema.org',
  '@type': 'Service',
  serviceType: name,
  provider: {
    '@type': 'LocalBusiness',
    name: business.name,
    url: `${business.siteUrl}/`,
    telephone: business.phone.e164,
  },
  areaServed: {
    '@type': 'Place',
    name: areaServed,
  },
  description,
});

export const faqSchema = (faqs: { question: string; answer: string }[]) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((faq) => ({
    '@type': 'Question',
    name: faq.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: faq.answer,
    },
  })),
});

export const breadcrumbSchema = (
  items: { name: string; url: string }[]
) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((item, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    name: item.name,
    item: item.url,
  })),
});

export const articleSchema = (
  title: string,
  description: string,
  datePublished: string,
  image: string,
  url: string
) => ({
  '@context': 'https://schema.org',
  '@type': 'Article',
  headline: title,
  description,
  datePublished,
  author: { '@type': 'Organization', name: 'TourMy.co', url: 'https://tourmy.co' },
  publisher: { '@type': 'Organization', name: 'TourMy.co', url: 'https://tourmy.co' },
  image,
  mainEntityOfPage: url,
});

// Helper to create service breadcrumbs
export const serviceBreadcrumbs = (pageName: string, pagePath: string) =>
  breadcrumbSchema([
    { name: 'Home', url: 'https://tourmy.co/' },
    { name: 'Services', url: 'https://tourmy.co/services' },
    { name: pageName, url: `https://tourmy.co${pagePath}` },
  ]);

export const industryBreadcrumbs = (pageName: string, pagePath: string) =>
  breadcrumbSchema([
    { name: 'Home', url: 'https://tourmy.co/' },
    { name: 'Industries', url: 'https://tourmy.co/industries' },
    { name: pageName, url: `https://tourmy.co${pagePath}` },
  ]);

export const resourceBreadcrumbs = (pageName: string, pagePath: string) =>
  breadcrumbSchema([
    { name: 'Home', url: 'https://tourmy.co/' },
    { name: 'Resources', url: 'https://tourmy.co/resources' },
    { name: pageName, url: `https://tourmy.co${pagePath}` },
  ]);
